import { NgModule } from "@angular/core";
import { NavigateBackComponent } from "./shared/navigate-back.component";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [CommonModule],
    declarations: [NavigateBackComponent],
    exports: [NavigateBackComponent]
})
export class SharedModule { }
